/** T-Lián 联 — app icon + name. 联 (lián) = connect, unite. */
export const BRAND = 'T-Lián';

export function Brand({ as: Tag = 'div', small = false }: { as?: 'div' | 'h1'; small?: boolean }) {
  return (
    <Tag className={`brand ${small ? 'brand-sm' : ''}`}>
      <img className="brand-icon" src="/logo.png" alt="" width={small ? 32 : 44} height={small ? 32 : 44} />
      <span className="brand-name">T-Lián</span>
      <span className="brand-zh" lang="zh-Hans">联</span>
    </Tag>
  );
}
